import ApplicationSerializer from "./application";

export default class ReservedIpSerializer extends ApplicationSerializer {
  usesProxy = true;

  primaryKey = "address";

  attrs = {
    address: "ipaddress",
    lockedToProject: "lockedtoaccount",
    server: "serverid",
    dataCenter: "datacenter",
  };

  getPayload(payload) {
    if (Array.isArray(payload)) {
      return payload;
    }

    let unwrapped = super.getPayload(payload);

    return unwrapped && typeof unwrapped === "object" ? unwrapped : payload;
  }

  normalize(modelClass, resourceHash, prop) {
    resourceHash.project = resourceHash.projectkey ?? resourceHash.project ?? resourceHash.account;

    return super.normalize(modelClass, resourceHash, prop);
  }
}
